import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getPersonalizationConfig',
    standalone: false
})
export class GetPersonalizationConfigPipe implements PipeTransform {
  transform(value: { personalizationConfig: string }): any {
    return JSON.parse(value.personalizationConfig);
  }
}
